import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components/Navbar';
import { Sidebar } from '../../components/Sidebar';

export default () => {
  return (
    <div>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              <div className="main_bg_color h-100">
                <div className="container-fluid">
                  <div className="row py-3">
                    <div className="col-md-12 col-lg-4 col-sm-6 px-4 mb-5">
                      <div>
                        <div className="card card_border">
                          <div className="div_background_color">
                            <h2 className>NEW<br /> INSTALL JOB<br /> REQUEST!</h2>
                          </div>
                          {/* <img className="card-img-top" src="../bootstrap4/img_avatar1.png" alt="Card image" style="width:100%"> */}
                          <div className=" job_bg  card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                            <p className="mb-2">Wrap Before: <span>12/22/2022</span></p>
                            <p>Offer Expires: <span>12/20/2022</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-4 col-sm-6 px-4 mb-5">
                      <Link to={"/designerjobview"} style={{textDecoration:"none",color: "#005E9D"}}>
                        <div>
                          <div className="card card_border div_posetion">
                            <img className="card_img_top" src={require("../../assets/img/jobs_JustDoIt_img.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                            <div className="photo_button"><button className="px-4 py-2 rounded-pill">install</button></div>
                            <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                              <p className="mb-2">Vehicle: <span>2014 Hino 155</span></p>
                              <p>Wrap Before: <span>12/15/22</span></p>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col-md-12 col-lg-4 col-sm-6 px-4 mb-5">
                      <div>
                        <div className="card card_border div_posetion">
                          <img className="card_img_top" src={require("../../assets/img/chat_img_3.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                          <div className="photo_button"><button className="px-4 py-2 rounded-pill">install</button></div>
                          <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                            <p className="mb-2">Vehicle: <span>2012, Isuzu, N-series</span></p>
                            <p>Wrap Before: <span>12/25/22</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-4 col-sm-6 px-4 mb-5">
                      <div>
                        <div className="card card_border div_posetion">
                          <img className="card_img_top" src={require("../../assets/img/chat_img_4.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                          <div className="photo_button"><button className="px-4 py-2 rounded-pill">Removal</button></div>
                          <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                            <p className="mb-2">Vehicle: <span>2018 BMW 5-Serise</span></p>
                            <p>Unwrap Before: <span>1/3/23</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-4 col-sm-6 px-4 mb-5">
                      <div>
                        <div className="card card_border div_posetion">
                          <img className="card_img_top" src={require("../../assets/img/chat_img_6.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                          <div className="photo_button"><button className="px-4 py-2 rounded-pill">Removal</button></div>
                          <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                            <p className="mb-2">Vehicle: <span>2005 volkswagon type 1</span></p>
                            <p>Unwrap Before: <span>1/10/2023</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-4 col-sm-6 px-4 mb-5">
                      <div>
                        <div className="card card_border div_posetion">
                          <img className="card_img_top" src={require("../../assets/img/chat_img_5.png")} alt="Card image" style={{width: '100%', height: '200px'}} />
                          <div className="photo_button"><button className="px-4 py-2 rounded-pill">Install</button></div>
                          <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                            <p className="mb-2">Vehicle: <span>Freigthliner</span></p>
                            <p>Wrap Before: <span>1/17/2023</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}
